//Inventory
export const GetAllInventoryItems = (id) => {
  return $.get('api/Inventory/GetAllInventoryItems?locationId=' + id)
}
export const GetInventoryDetialById = (id) => {
  return $.get('api/Inventory/GetInventoryDetialById?inventoryDetailsId=' + id)
}
export const PreRequisites = () => {
  return $.get('api/Inventory/GetInventoryDetailsPreRequisites')
}

export const AddInventoryItem = (model) => {
  return $.post('api/Inventory/AddInventoryItem', model)
}

export const UpdateInventoryDetails = (model) => {

  return $.post('api/Inventory/UpdateInventoryDetails', model)
}



export const DeleteInventory = (id) => {
  return $.post('api/Inventory/DeleteInventoryDetialsById?inventoryDetailsId=' + id)
}

// Maintenance

export const GetMaintenance = (id) => {
  return $.get('api/Maintenance/GetMaintenance?locationId=' + id)
}


export const UpdateMaintenance = (model) => {

  return $.post('api/Maintenance/UpdateMaintenance', model)
}

export const AddMaintenance = (model) => {
  return $.post('api/Maintenance/AddMaintenance', model)
}

export const DeleteMaintenance = (id) => {
  return $.post('api/Maintenance/DeleteMaintenance?MaintenanceId=' + id)
}


export const GetPrerequisites = (id) => {
  return $.get('api/Maintenance/GetPrerequisites?locationId=' + id)
}



export const GetAllUsers = (id) => {
  return $.get('api/Maintenance/GetAllUsers?locationId=' + id)
}


//Training

export const GetAllTrainings = (id) => {
  return $.get('api/Training/GetAllTrainingsByLocationId?locationId=' + id)
}

export const GetTrainingTypes = () => {
  return $.get('api/Training/GetTrainingTypes')
}

/*export const GetAllOrganizers = () => {
  return $.get('api/Training/GetAllOrganizers')
}*/

export const GetAllOrganizers = (id) => {
  return $.get('api/Training/GetAllUsers')
}

/*
export const GetSessionDocuments = () => {
  return $.get('api/Training/GetSessionDocuments')
}
*/

export const GetSessionDocuments = () => {
  var LocationId = 0
  return $.get('Compliance/GetAllComplianceDocumentDetails')
}

/*export const GetSessionDocuments = () => {
  return $.get('api/Training/GetSessionDocuments')
}*/

export const GetAllUserstraining = () => {
  return $.get('api/Training/GetAllUsers')
}

export const GetMahcCodes = () => {
  return $.get('api/Training/GetMahcCodes')
}

export const GetSupplyItems = (id) => {
  return $.get('api/Training/GetSupplyItemsByTrainingTypeId?trainingTypeId=' + id)
}

export const GetEquipments = (id) => {
  return $.get('api/Training/GetEquipmentsByTrainingTypeId?trainingTypeId=' + id)
}

export const AddTraining = (model) => {

  return $.post('api/Training/AddTraining', model)
}
export const UpdateTraining = (model) => {

  return $.post('api/Training/UpdateTraining', model)
}
export const DeleteTraining = (id) => {

  return $.post('api/Training/DeleteTraining?trainingId=' + id)
}


export const GetSessionDetailsByTrainingId = (id) => {
  return $.get('api/Training/GetSessionDetailsByTrainingId?trainingId=' + id)
}
export const UsersCompletedSession = (model) => {
  return $.ajax({
    type: "POST",
    url: "api/Training/UsersCompletedSession",

    data: JSON.stringify(model),
    contentType: "application/json",

  });
  // return $.post('api/Training/UsersCompletedSession',model)
}

// Api calls for accidents and incidents

export const GetAllSupervisor = () => {
  return $.get('api/Training/GetAllSupervisor')
}

export const GetAllUserst = () => {
  return $.get('api/Training/GetAllUsers')
}


export const GetAllRoles = () => {
  return $.get('Position/GetPositions')
}

export const GetAllIncidents = (id, poolid) => {
  return $.get('api/Incident/GetAllIncidents?LocationId=' + id + '&PoolId=' + poolid)
}
export const GetIncidentById = (id) => {
  return $.get('api/Incident/GetIncidentDetailsById?Id=' + id)
}

export const GetAllStaffMember = () => {
  return $.get('api/Training/GetAllStaffMember')
}
export const GetAllLifeguard = () => {
  return $.get('api/Training/GetAllLifeguard')
}
export const GetAllPoolsByUserName = () => {
  return $.get('api/Log/GetAllPoolsByUserName')
}


export const CreateIncident = (model) => {

  return $.post('api/Incident/CreateIncident', model)
}

export const UpdateIncident = (model) => {
  return $.post('api/Incident/UpdateIncident', model)
}


export const DeleteIcident = (id) => {
  return $.post('api/Incident/DeleteIncident?Id=' + id)
}
export const GetLocationsPools = () => {
  let needpool = true;
  return $.get('Location/GetLocations?havingPools=' + needpool)

}
export const GetPools = (locationid) => {
  if (!locationid) locationid = 0
  return $.get('Pool/GetPools?locationId=' + locationid)

}
export const GetUsersByLocation = (locationid) => {
  return $.get('api/Maintenance/GetAllUsers?locationId=' + locationid)
}



// WEBPACK FOOTER //
// ./src/pages/HealthSafety/healthsafety.service.js